/** The client room: a project is FOR a named client, the client has
 *  one link, and Send puts a cut or a draft in it. Studio side
 *  (ClientRoom.tsx, the project header, the projects page) and the
 *  client's own page (ArollSharePage.tsx). */
export const room = {
  /** Dialog heading the first time something is sent from a project. */
  'room.askTitle': 'Who is this for?',
  'room.askBody':
    'Your client gets one link. Everything you send them, from any project, shows up there.',
  /** Label above the chips of clients the studio already has. */
  'room.askExisting': 'Your clients',
  'room.askPlaceholder': 'Client name',
  'room.askNewLabel': 'Or a new client',
  'room.askSend': 'Send',
  'room.askSave': 'Save',
  'room.cancel': 'Cancel',
  /** The project already had an old-style link when it joins a client. */
  'room.linkChoiceTitle': 'This project already has a link out',
  'room.linkChoiceBody':
    'Keep it working and it will open everything you send {name}. Or turn it off, and share {name}’s link from now on.',
  'room.linkKeep': 'Keep it working',
  'room.linkRevoke': 'Turn it off',
  /** Toasts. */
  'room.sentToast': 'Sent to {name}. Their link is copied.',
  'room.sentToastNoCopy': 'Sent to {name}.',
  'room.unsentToast': 'Taken back. {name} can no longer see it.',
  'room.linkCopied': '{name}’s link is copied',
  'room.nothingSentYet': 'Send something first, then there is a link to copy.',
  /** Project header: the client chip and its menu. */
  'room.headerFor': 'For {name}',
  'room.headerSet': 'Set client',
  'room.menuCopy': 'Copy {name}’s link',
  'room.menuChange': 'Change client',
  'room.menuRename': 'Rename client',
  'room.menuOptions': 'Other links',
  'room.renameTitle': 'Rename {name}',
  /** Cut row, above the review player. */
  'room.send': 'Send to {name}',
  'room.sendGeneric': 'Send to client',
  'room.sentOpened': 'Sent to {name} · opened',
  'room.sentNotOpened': 'Sent to {name} · not opened yet',
  'room.copyLink': 'Copy link',
  'room.unsend': 'Unsend',
  /** Projects page: one line on each card. */
  'room.cardChanges': '{name} asked for changes',
  'room.cardChangesNoName': 'Client asked for changes',
  'room.cardVersion': '{name} sent a version',
  'room.cardVersionNoName': 'Client sent a version',
  'room.cardWith_one': 'With {name}',
  'room.cardWith_other': '{n} with {name}',
  'room.cardWithNoName': 'With client',
  'room.cardApproved': 'Approved',
  /** The client's page. */
  'room.pageTitle': 'For {name}',
  'room.pageWaiting': 'Waiting on you',
  'room.pageNothingWaiting': 'Nothing is waiting on you right now.',
  'room.pageDone': 'Already looked at',
  'room.pageBack': 'Everything sent to you',
  'room.pageEmpty': 'Nothing has been sent to you yet.',
  /** What a row is, in the client's words. */
  'room.kindCut': 'Cut',
  'room.kindDraft': 'Interview selects',
  'room.statusReview': 'To review',
  'room.statusYourCopy': 'Your version',
  'room.statusVersionSent': 'Your version sent',
  'room.madeOn': 'made on {draft}',
  'room.statusChanges': 'You asked for changes',
  'room.statusApproved': 'Approved',
  'room.open': 'Open',
} as const;
